/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  OAuthErrorResponseModel,
  TokenResponseModel,
} from '../models/index';
import {
    OAuthErrorResponseModelFromJSON,
    OAuthErrorResponseModelToJSON,
    TokenResponseModelFromJSON,
    TokenResponseModelToJSON,
} from '../models/index';

export interface ExchangePasswordRequest {
    grantType?: string;
    clientId?: string;
    username?: string;
    password?: string;
    scope?: string;
}

export interface ExchangeRefreshTokenRequest {
    grantType?: string;
    clientId?: string;
}

/**
 * 
 */
export class TokenAuthApi extends runtime.BaseAPI {

    /**
     * OAuth2 token endpoint — resource-owner password credentials grant. Returns a  Ptw.Ptw100.Web.Mvc.Models.TokenAuth.TokenResponseModel; the refresh token is delivered through the HttpOnly  `refresh-token` cookie, never in the body.
     */
    async exchangePasswordRaw(requestParameters: ExchangePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['grantType'] != null) {
            formParams.append('grant_type', requestParameters['grantType'] as any);
        }

        if (requestParameters['clientId'] != null) {
            formParams.append('client_id', requestParameters['clientId'] as any);
        }

        if (requestParameters['username'] != null) {
            formParams.append('username', requestParameters['username'] as any);
        }

        if (requestParameters['password'] != null) {
            formParams.append('password', requestParameters['password'] as any);
        }

        if (requestParameters['scope'] != null) {
            formParams.append('scope', requestParameters['scope'] as any);
        }

        const response = await this.request({
            path: `/api/connect/token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => TokenResponseModelFromJSON(jsonValue), "TokenResponseModel" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => OAuthErrorResponseModelFromJSON(jsonValue), "OAuthErrorResponseModel" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => TokenResponseModelFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * OAuth2 token endpoint — resource-owner password credentials grant. Returns a  Ptw.Ptw100.Web.Mvc.Models.TokenAuth.TokenResponseModel; the refresh token is delivered through the HttpOnly  `refresh-token` cookie, never in the body.
     */
     async exchangePassword(requestParameters: ExchangePasswordRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TokenAuthApi['exchangePasswordRaw']>>, TokenResponseModel>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = TokenResponseModel;

         const response = this.exchangePasswordRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * OAuth2 token endpoint — refresh-token grant. Returns a Ptw.Ptw100.Web.Mvc.Models.TokenAuth.TokenResponseModel. The refresh  token is read from the HttpOnly `refresh-token` cookie (browser clients) and rotated back into it.
     */
    async exchangeRefreshTokenRaw(requestParameters: ExchangeRefreshTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['grantType'] != null) {
            formParams.append('grant_type', requestParameters['grantType'] as any);
        }

        if (requestParameters['clientId'] != null) {
            formParams.append('client_id', requestParameters['clientId'] as any);
        }

        const response = await this.request({
            path: `/api/connect/token/refresh`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => TokenResponseModelFromJSON(jsonValue), "TokenResponseModel" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => OAuthErrorResponseModelFromJSON(jsonValue), "OAuthErrorResponseModel" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => TokenResponseModelFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * OAuth2 token endpoint — refresh-token grant. Returns a Ptw.Ptw100.Web.Mvc.Models.TokenAuth.TokenResponseModel. The refresh  token is read from the HttpOnly `refresh-token` cookie (browser clients) and rotated back into it.
     */
     async exchangeRefreshToken(requestParameters: ExchangeRefreshTokenRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TokenAuthApi['exchangeRefreshTokenRaw']>>, TokenResponseModel>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = TokenResponseModel;

         const response = this.exchangeRefreshTokenRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Logout: immediately invalidates the current session\'s access tokens by removing the per-session  token-validity-key cache entry, revokes the session\'s entity-lock tokens, clears the  `refresh-token`, session and tenant cookies, and raises a Ptw.Ptw100.Web.Mvc.Authentication.Logout.UserLoggedOutEvent so the  session\'s tokens and OpenIddict authorization are revoked off the request thread. The session and  authorization identifiers are read from cookies, so logout works even when the request carries no  Bearer token.
     */
    async logOutRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/connect/logout`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     * Logout: immediately invalidates the current session\'s access tokens by removing the per-session  token-validity-key cache entry, revokes the session\'s entity-lock tokens, clears the  `refresh-token`, session and tenant cookies, and raises a Ptw.Ptw100.Web.Mvc.Authentication.Logout.UserLoggedOutEvent so the  session\'s tokens and OpenIddict authorization are revoked off the request thread. The session and  authorization identifiers are read from cookies, so logout works even when the request carries no  Bearer token.
     */
     async logOut(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TokenAuthApi['logOutRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.logOutRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

}
